module.exports = __webpack_public_path__ + "img/petstairs32.7e6cf444.jpg";